export interface CurriculumSubject {
  name: string;
  icon: string;
  color: string;
}

const primaryCore: CurriculumSubject[] = [
  { name: "Türkçe", icon: "ri-font-size", color: "bg-primary-100 text-primary-700" },
  { name: "Matematik", icon: "ri-function-line", color: "bg-secondary-100 text-secondary-800" },
  { name: "Hayat Bilgisi", icon: "ri-earth-line", color: "bg-accent-100 text-accent-800" },
  { name: "İngilizce", icon: "ri-english-input", color: "bg-sky-100 text-sky-800" },
  { name: "Görsel Sanatlar", icon: "ri-palette-line", color: "bg-pink-100 text-pink-700" },
  { name: "Müzik", icon: "ri-music-2-line", color: "bg-violet-100 text-violet-700" },
  { name: "Beden Eğitimi ve Oyun", icon: "ri-run-line", color: "bg-emerald-100 text-emerald-700" },
];

const fourthGrade: CurriculumSubject[] = [
  { name: "Türkçe", icon: "ri-font-size", color: "bg-primary-100 text-primary-700" },
  { name: "Matematik", icon: "ri-function-line", color: "bg-secondary-100 text-secondary-800" },
  { name: "Fen Bilimleri", icon: "ri-flask-line", color: "bg-accent-100 text-accent-800" },
  { name: "Sosyal Bilgiler", icon: "ri-global-line", color: "bg-sky-100 text-sky-800" },
  { name: "İngilizce", icon: "ri-english-input", color: "bg-indigo-100 text-indigo-700" },
  { name: "Din Kültürü ve Ahlak Bilgisi", icon: "ri-book-mark-line", color: "bg-teal-100 text-teal-800" },
  { name: "İnsan Hakları, Yurttaşlık ve Demokrasi", icon: "ri-community-line", color: "bg-orange-100 text-orange-800" },
  { name: "Trafik Güvenliği", icon: "ri-road-map-line", color: "bg-yellow-100 text-yellow-800" },
  { name: "Görsel Sanatlar", icon: "ri-palette-line", color: "bg-pink-100 text-pink-700" },
  { name: "Müzik", icon: "ri-music-2-line", color: "bg-violet-100 text-violet-700" },
  { name: "Beden Eğitimi ve Oyun", icon: "ri-run-line", color: "bg-emerald-100 text-emerald-700" },
];

const middleSchool: CurriculumSubject[] = [
  { name: "Türkçe", icon: "ri-font-size", color: "bg-primary-100 text-primary-700" },
  { name: "Matematik", icon: "ri-function-line", color: "bg-secondary-100 text-secondary-800" },
  { name: "Fen Bilimleri", icon: "ri-flask-line", color: "bg-accent-100 text-accent-800" },
  { name: "Sosyal Bilgiler", icon: "ri-global-line", color: "bg-sky-100 text-sky-800" },
  { name: "İngilizce", icon: "ri-english-input", color: "bg-indigo-100 text-indigo-700" },
  { name: "Din Kültürü ve Ahlak Bilgisi", icon: "ri-book-mark-line", color: "bg-teal-100 text-teal-800" },
  { name: "Bilişim Teknolojileri ve Yazılım", icon: "ri-code-s-slash-line", color: "bg-violet-100 text-violet-700" },
  { name: "Görsel Sanatlar", icon: "ri-palette-line", color: "bg-pink-100 text-pink-700" },
  { name: "Müzik", icon: "ri-music-2-line", color: "bg-yellow-100 text-yellow-800" },
  { name: "Beden Eğitimi ve Spor", icon: "ri-run-line", color: "bg-emerald-100 text-emerald-700" },
];

export function curriculumForGrade(grade: string | null): CurriculumSubject[] {
  const number = Number(grade);
  if (number === 4) return fourthGrade;
  if (number >= 1 && number <= 3) return primaryCore;
  if (number >= 5 && number <= 8) return middleSchool;
  return [];
}
